<template lang="pug">
  .sort-area
    .sort-area-inner
      span.count
        | {{ Number(total).toLocaleString() }}件
        | ヒット
      .sort-link
        select(v-model="order")
          option(v-for="option in options" :value="option.value") {{ option.text }}
      .sort-btn-wrapper
        a.open-search-button(@click="toggleSidebar") 検索条件
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        options: [
          { text: 'ソート順指定なし', value: '' },
          { text: '出稿予算/当月(昇順)', value: 'budget_current_month:asc' },
          { text: '出稿予算/当月(降順)', value: 'budget_current_month:desc' },
          { text: '出稿予算/先月(昇順)', value: 'budget_last_month:asc' },
          { text: '出稿予算/先月(降順)', value: 'budget_last_month:desc' },
          { text: '出稿予算/3ヶ月(昇順)', value: 'budget_last_quarter:asc' },
          { text: '出稿予算/3ヶ月(降順)', value: 'budget_last_quarter:desc' },
          { text: '出稿予算/6ヶ月(昇順)', value: 'budget_last_harf_year:asc' },
          { text: '出稿予算/6ヶ月(降順)', value: 'budget_last_harf_year:desc' },
          { text: '出稿予算/1年(昇順)', value: 'budget_last_year:asc' },
          { text: '出稿予算/1年(降順)', value: 'budget_last_year:desc' },
        ],
      }
    },
    computed: {
      ...mapState({
        total: state => state.corporation.pagination.totalCount,
        order: state => state.searchCorporation.query.order,
      }),
      order: {
        get () {
          return this.$store.state.searchCorporation.query.order
        },
        set (value) {
          this.$store.commit('searchCorporation/order', value)
        },
      },
    },
    watch: {
      order () {
        this.$emit('searchOrderBy', this.order)
      },
    },
    methods: {
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CorporationSortArea.vue